import React, { useState } from 'react';
import { createPortal } from 'react-dom';

function InfoSvg({ size = 14 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 14 14" fill="none" aria-hidden="true">
      <circle cx="7" cy="7" r="6" stroke="currentColor" strokeWidth="1.2" />
      <path d="M7 6.2V10" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
      <circle cx="7" cy="4.25" r="0.75" fill="currentColor" />
    </svg>
  );
}

/** Info icon with Mention Share chart-style hover tooltip (map-hover-tooltip + geo-line-chart-tooltip). */
export default function MetricInfoIcon({
  text,
  title,
  ariaLabel,
  className = 'geo-metric-info',
  iconSize = 14,
}) {
  const [tip, setTip] = useState(null);

  if (!text) return null;

  const showTip = (event) => {
    setTip({ x: event.clientX, y: event.clientY });
  };

  const hideTip = () => setTip(null);

  return (
    <>
      <span
        className={className}
        aria-label={ariaLabel || (title ? `${title}. ${text}` : text)}
        onMouseEnter={showTip}
        onMouseMove={showTip}
        onMouseLeave={hideTip}
      >
        <InfoSvg size={iconSize} />
      </span>
      {tip && typeof document !== 'undefined' && createPortal(
        <div
          className="map-hover-tooltip geo-line-chart-tooltip geo-metric-tooltip"
          style={{ left: tip.x, top: tip.y }}
          role="tooltip"
        >
          {title ? (
            <div className="geo-line-chart-tooltip__date">{title}</div>
          ) : null}
          <p className="geo-metric-tooltip__body">{text}</p>
        </div>,
        document.body,
      )}
    </>
  );
}
